import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

document.querySelectorAll('.price-history-graph-shortcode').forEach(el => {
  const storecode = el.getAttribute('data-storecode');
  new Vue({
    render: h => h(App, {
      props: {
        storecode
      }
    }),
  }).$mount(el)
})